import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Card, Form, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ProjectDetails from './ProjectDetails';
import '../newRow.css';
import ContractResearchSection from '@rd-web-markets/market/dist/technicalProof/creating_application/ContractResearchSection';
import ProjectDocumentationTab from '../project_documentation/ProjectDocumentationTab';
import Employee from './Employee';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import ProjectOwner from '../project_owner/ProjectOwner';
import claimProjectReportService from '@rd-web-markets/shared/dist/services/project_report/claim_project_report.service';
const ProjectDetailTabs = _ref => {
  let {
    setSelectedProject,
    selectedProject,
    setProjectReports,
    projectReports,
    handleToaster
  } = _ref;
  const [key, setKey] = useState('name_list');
  const {
    t
  } = useTranslation();
  const {
    search
  } = useLocation();
  const history = useHistory();
  const selectProjectDetails = e => {
    const subTab1Key = new URLSearchParams(search).get('sub_tab1');
    history.push({
      search: `?main_tab=project_details&sub_tab1=${subTab1Key}&p_id=${e.target.value}`
    });
  };
  const goToTab = key => {
    setKey(key);
    history.push({
      search: `?main_tab=project_details&sub_tab1=${key}&p_id=${selectedProject.id}`
    });
  };
  if (!projectReports.length) return /*#__PURE__*/React.createElement("div", null, t('there_is_no_project_selected'));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, t('project')), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, selectedProject?.project_name), /*#__PURE__*/React.createElement(Col, {
    md: 6
  }), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, t('select_project')), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, /*#__PURE__*/React.createElement(Form.Control, {
    defaultValue: new URLSearchParams(search).get('p_id'),
    value: selectedProject?.id,
    as: "select",
    name: "project_select",
    onChange: selectProjectDetails,
    size: "md"
  }, /*#__PURE__*/React.createElement("option", {
    value: null
  }), projectReports.map((p, i) => {
    return /*#__PURE__*/React.createElement("option", {
      key: p.id,
      value: p.id
    }, p.project_name);
  })))), !selectedProject ? /*#__PURE__*/React.createElement("div", null, t('please_select_a_project')) : /*#__PURE__*/React.createElement(Card, {
    className: "mt-3"
  }, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Tabs, {
    onSelect: goToTab,
    activeKey: new URLSearchParams(search).get('sub_tab1'),
    className: "mb-3 ms-3",
    defaultActiveKey: 'employee'
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "employee",
    title: t('employee')
  }, /*#__PURE__*/React.createElement(Employee, {
    selectedProjectId: selectedProject.id,
    selectedProject: selectedProject
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "project_owner",
    title: t('project_owner')
  }, /*#__PURE__*/React.createElement(ProjectOwner, {
    setSelectedProject: setSelectedProject,
    projectOwners: selectedProject.project_elster_detail.project_owners,
    setProjectReports: setProjectReports,
    projectReports: projectReports,
    selectedProjectId: selectedProject.id,
    selectedProject: selectedProject
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "contract_research",
    title: t('contract_research')
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-warning"
  }, "This section is under development. Please do not test."), /*#__PURE__*/React.createElement(ContractResearchSection, {
    report: selectedProject
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "project_details_listing",
    title: t('project_details_listing')
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-warning"
  }, "Please test everything except accuracy of calculations. calculations should be done after contractor research is done."), /*#__PURE__*/React.createElement(ProjectDetails, {
    projectElsterDetailId: selectedProject.project_elster_detail.id,
    search: search
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "project_documentation",
    title: t('project_documentation')
  }, /*#__PURE__*/React.createElement(ProjectDocumentationTab, {
    claimProjectReport: selectedProject,
    handleToaster: handleToaster,
    setProjectReports: setProjectReports,
    projectReports: projectReports
  }))))));
};
export default ProjectDetailTabs;